module.exports = __webpack_public_path__ + "185fc1c8ad0035e725c17b61ee26f665.pdf";